import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { getInAppPaymentsUrl } from 'pricing-pages-lib/utils/urls';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import SignupButton from '../common/SignupButton';
import { jsx as _jsx } from "react/jsx-runtime";
const BringCommerceCTAs = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const goToPaymentsUrl = getInAppPaymentsUrl();
  const handleGoToPayments = () => {
    // Add tracking if Payments Page View tracking does not have referrer URL
    // getUsageTracker().track('externalLinkClick', {
    //   name: 'go-to-payments-link',
    //   url: goToPaymentsUrl,
    // });
  };

  // Sign-up on public page
  if (!isAppAuth) {
    return /*#__PURE__*/_jsx(SignupButton, {
      sourceId: "pricing-pages-commerce-hub-page",
      use: "primary",
      productLine: COMMERCE
    });
  }

  // Go to payments zero state in-app
  return /*#__PURE__*/_jsx(UIButton, {
    use: "primary",
    href: goToPaymentsUrl,
    onClick: handleGoToPayments,
    "data-test-id": "commerce-go-to-payments-zero-state",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.commerce.goToPayments"
    })
  });
};
export default BringCommerceCTAs;